@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.filter-item {
  display: flex;
  flex-direction: column;
  margin-right: @space-16;
  margin-bottom: @space-16;
  min-width: 130px;

  .label-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: @space-8;
  }

  .label {
    font-weight: 500;
    margin-right: @space-8;
  }

  .tooltip-icon {
    display: flex;
    align-items: center;
    color: var(--grey-500);
    cursor: pointer;
    font-size: 14px;

    &:hover {
      color: var(--grey-700);
    }
  }

  .input {
    width: 100%;
  }

  @media (max-width: 768px) {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
  }
}
